module.exports = __webpack_public_path__ + "media/images/Guide Image-acf5fd4fdfc3296626d8b875c50b8e53.jpg";